<template>
  <div>
    <sportsbook-editor v-if="bookmaker" pageTitle="Edit Sportsbook" :bookmaker="bookmaker" />
  </div>
</template>
<script>
import BookMaker from '@/models/BookMaker'
import SportsbookEditor from '../CreateSportsBook'

export default {
  components: {
    SportsbookEditor
  },
  data () {
    return {
      bookmaker: null
    }
  },
  mounted () {
    BookMaker.find(this.$route.params.id)
      .then((res) => {
        this.bookmaker = res.data
      })
  }
}
</script>
